import React from "react";
import KpiSummaryForm from "../components/forms/KpiSumaryForm";

const Logistics: React.FC = () => {
  return (
   <>
   <KpiSummaryForm />
   </>
  );
};

export default Logistics;

